export enum WrapperEvent {
    StopAutobet = "StopAutobet",
    EnableSpin = "EnableSpin",
    DisableSpin = "DisableSpin",
    Pause = "Pause",
    Resume = "Resume"
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/wrapper/WrapperEvent.ts